import React from "react";
import usePrivateLink from "../config/usePrivateLink";
import ModuleHeader from "../components/ModuleHeader/ModuleHeader";

const META_DASHBOARD_URL = "https://metawhatsapp.billbazaar.in/";

const META_TABS = [
  {
    id: "send-whatsapp",
    path: "/meta/wa_send_msg",
    icon: "ri-send-plane-line",
    title: "Send WhatsApp Notification",
  },
  {
    id: "send-app-notification",
    path: "/notification/send",
    icon: "ri-notification-badge-line",
    title: "Send App Notification",
  },
  {
    id: "whatsapp-history",
    path: "/meta/history",
    icon: "ri-whatsapp-line",
    title: "WhatsApp History",
  },
  {
    id: "notification-history",
    path: "/notification/history",
    icon: "ri-notification-3-line",
    title: "Notification History",
  },
  {
    id: "meta-templates",
    path: "/meta/templates",
    icon: "ri-file-copy-2-line",
    title: "Meta Templates",
  },
  {
    id: "configuration",
    path: "/message/list",
    icon: "ri-settings-3-line",
    title: "Configuration",
  },
  {
    id: "wallet",
    path: "/meta/wallet",
    icon: "ri-wallet-3-line",
    title: "Wallet",
  },
  {
    id: "meta-dashboard",
    path: META_DASHBOARD_URL,
    accessPath: "/meta/dashboard",
    external: true,
    icon: "ri-dashboard-3-line",
    title: "Meta Dashboard",
    description: "Open Meta Dashboard in a new tab",
  },
];

export default function Master() {
  return ;
  const hasAccess = usePrivateLink();

  const tabs = META_TABS.filter((tab) => hasAccess(tab.accessPath || tab.path));

  return (
    <ModuleHeader
      title="Meta Management"
      subtitle="Manage WhatsApp notifications and configuration"
      tabs={tabs}
    />
  );
}
